import * as React from 'react';
import { AffectedResponse } from '../questions/affectedResponse';
import { isValidAndNotEmptyRegex } from '../../libs/isValidRegex';
import { focusPointMatchHelper, incorrectSequenceMatchHelper } from '../../quill-marking-logic/src/main';
import { Response } from './response';

interface ResponseListProps {
  Constants: any;
  addResponsesToMassEditArray: Function;
  admin: boolean;
  ascending?: boolean;
  conceptID?: string;
  concepts?: any;
  conceptsFeedback?: any;
  deleteResponse: Function;
  dispatch: Function;
  expand?: Function;
  expanded: any;
  fillInTheBlank?: boolean;
  getGradedResponsesWithCallback: Function;
  getMatchingResponse?: Function;
  getResponse?: Function;
  massEdit: any;
  massEditActions: any;
  mode?: string;
  question?: any;
  questionActions: any;
  questionID: string;
  rematchOne?: Function;
  removeResponsesFromMassEditArray: Function;
  responses: Array<any>;
  selectedFocusPoints?: Array<any>;
  selectedIncorrectSequences?: Array<any>;
  states?: any;
  submitResponseEdit: Function;
  updateParentResponse?: Function;
}

export const ResponseList: React.FC<ResponseListProps> = ({
  Constants,
  addResponsesToMassEditArray,
  admin,
  ascending,
  conceptID,
  concepts,
  conceptsFeedback,
  deleteResponse,
  dispatch,
  expand,
  expanded,
  fillInTheBlank,
  getGradedResponsesWithCallback,
  getMatchingResponse,
  getResponse,
  massEdit,
  massEditActions,
  mode,
  question,
  questionActions,
  questionID,
  rematchOne,
  removeResponsesFromMassEditArray,
  responses,
  selectedFocusPoints,
  selectedIncorrectSequences,
  states,
  submitResponseEdit,
  updateParentResponse,
}) => {
  function allResponsesChecked() {
    return responses.every((r) => {
      return (
        massEdit.selectedResponses.includes(r.key) ||
        massEdit.selectedResponses.includes(r.id)
      );
    });
  }

  function addAllResponsesToMassEdit() {
    const keys = responses.map((r) => r.id);
    dispatch(addResponsesToMassEditArray(keys));
  }

  function removeAllResponsesFromMassEdit() {
    const keys = responses.map((r) => r.id);
    dispatch(removeResponsesFromMassEditArray(keys));
  }

  function addOrRemoveAllResponsesFromMassEdit() {
    if (allResponsesChecked()) {
      removeAllResponsesFromMassEdit();
    } else {
      addAllResponsesToMassEdit();
    }
  }

  function renderResponse(resp) {
    return (
      <Response
        admin={admin}
        allExpanded={expanded}
        ascending={ascending}
        conceptID={conceptID}
        concepts={concepts}
        conceptsFeedback={conceptsFeedback}
        Constants={Constants}
        deleteResponse={deleteResponse}
        dispatch={dispatch}
        expand={expand}
        expanded={expanded[resp.key]}
        fillInTheBlank={fillInTheBlank}
        getGradedResponsesWithCallback={getGradedResponsesWithCallback}
        getMatchingResponse={getMatchingResponse}
        getResponse={getResponse}
        key={resp.key}
        massEdit={massEdit}
        massEditActions={massEditActions}
        mode={mode}
        passedResponse={resp}
        question={question}
        questionActions={questionActions}
        questionID={questionID}
        readOnly={admin}
        rematchOne={rematchOne}
        responses={responses}
        state={states ? states[questionID] : {}}
        states={states}
        submitResponseEdit={submitResponseEdit}
        updateParentResponse={updateParentResponse}
      />
    );
  }

  const responseListItems =
    responses &&
    responses.map((resp) => {
      if (
        resp &&
        resp.statusCode !== 1 &&
        resp.statusCode !== 0 &&
        selectedIncorrectSequences
      ) {
        const incorrectSequences = selectedIncorrectSequences.filter(isValidAndNotEmptyRegex);
        const anyMatches = incorrectSequences.some((inSeq) =>
          incorrectSequenceMatchHelper(resp.text, inSeq)
        );
        if (anyMatches) {
          return <AffectedResponse key={resp.key}>{renderResponse(resp)}</AffectedResponse>;
        }
      }
      if (resp && selectedFocusPoints) {
        const focusPoints = selectedFocusPoints.filter(isValidAndNotEmptyRegex);
        const noMatchedFocusPoints = focusPoints.every(
          (fp) => !focusPointMatchHelper(resp.text, fp)
        );
        if (noMatchedFocusPoints) {
          return <AffectedResponse key={resp.key}>{renderResponse(resp)}</AffectedResponse>;
        }
      }

      return renderResponse(resp);
    });

  return (
    <div style={{ marginTop: '20px' }}>
      <span style={{ paddingLeft: '15px' }}>
        <label>
          <input
            checked={allResponsesChecked()}
            onChange={addOrRemoveAllResponsesFromMassEdit}
            style={{ marginRight: '14px' }}
            type="checkbox"
          />
          Check All Responses On Page
        </label>
      </span>
      <div>{responseListItems}</div>
    </div>
  );
};
